module.exports = __webpack_public_path__ + "img/match--type2_img5.cf393172.png";